const updateCart = async (id, qty) => {
    let updates = {};
    updates[id] = qty;

    try {
        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates, sections: 'cart-drawer' })
        });

        if (!response.ok) return;
        const data = await response.json();

        setTimeout(() => {
            updateCartDrawer(data);
        }, 1000);
    } catch (error) {
        console.error('Error:', error);
    }
};

const updateCartDrawer = (data) => {
    const updated_cart_drawer = data.sections['cart-drawer'];
    const parser = new DOMParser();
    const updated_cart_drawer_document = parser.parseFromString(updated_cart_drawer, 'text/html');
    const previous_cart_drawer = document.querySelector("#shopify-section-cart-drawer #CartDrawer");
    previous_cart_drawer.innerHTML = updated_cart_drawer_document.querySelector('#shopify-section-cart-drawer #CartDrawer').innerHTML;
};

const addCart = async (id, isChildProduct) => {
    const parent_product = document.querySelector('.offer.bg-custom.text-custom .free-add-on');

    if (!parent_product) return;

    const title = parent_product.dataset.name;

    let formData = {
        items: [
            {
                id: id,
                quantity: isChildProduct ? 1 : 0, // Set quantity to 0 for parent product
                properties: {
                    _attachment: title
                }
            }
        ]
    };

    formData.sections = "cart-drawer,variant-added";

    try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        });

        if (response.ok) {
            const data = await response.json();
            setTimeout(() => {
                updateCartDrawer(data);
            }, 1000);
        } else {
            throw new Error('Failed to add item to cart');
        }

    } catch (error) {
        console.error('Error:', error);
    }
};

const cartButtonEvent = async () => {
    const checkbox = document.getElementById('add-on-check');

    if (!checkbox.checked) return

    console.log("Working123123=>>")
    const giftProduct = document.querySelector('.offer.bg-custom.text-custom .free-add-on');

    if (!giftProduct) return;

    const giftProductId = giftProduct.dataset.id;

    setTimeout(async () => {
        await addCart(+giftProductId, true); // Specify that it's a child product
    }, 1000);
};

const getCart = async () => {
    const response = await fetch(window.Shopify.routes.root + 'cart.js');
    if (!response.ok) return;
    return await response.json();
};

const removeGiftProduct = async () => {
    const cart_drawer = document.querySelector('.cart-drawer');
    if (!cart_drawer) return;

    cart_drawer.addEventListener('click', async (e) => {
        if (e.target.classList.contains('link')) {
            const currentQty = 0;
            const line_item = e.target.closest('.line-item');
            const title = line_item.querySelector('.line-item__info .reversed-link').innerText;

            const cart_data = await getCart();
            const matchingIds = [];

            cart_data.items.forEach(entry => {
                if ((entry.properties._attachment && entry.properties._attachment === title) ||
                    (entry.properties._match && entry.properties._match === title)) {
                    if (entry.properties._attachment) {
                        matchingIds.push(entry.key);
                    }
                }
            });

            if (matchingIds.length > 0) {
                setTimeout(async () => {
                    await updateCart(matchingIds[0], currentQty);
                }, 500);
            }
        }
    });
};

const addGiftProduct = async () => {
    const cart_button = document.querySelector('.product-info__buy-buttons .shopify-product-form button');
    if (!cart_button) return;
    cart_button.addEventListener('click', cartButtonEvent);
};

const changeGiftProduct = async () => {
    const cart_drawer = document.querySelector('.cart-drawer');
    if (!cart_drawer) return;

    cart_drawer.addEventListener('change', async (e) => {
        if (e.target.classList.contains('quantity-input')) {
            const currentQty = e.target.value;
            const line_item = e.target.closest('.line-item');
            const title = line_item.querySelector('.line-item__info .reversed-link').innerText;

            const cart_data = await getCart();
            const matchingIds = [];

            cart_data.items.forEach(entry => {
                if ((entry.properties._attachment && entry.properties._attachment === title) ||
                    (entry.properties._match && entry.properties._match === title)) {
                    if (entry.properties._attachment) {
                        matchingIds.push(entry.key);
                    }
                }
            });

            if (matchingIds.length > 0) {
                setTimeout(async () => {
                    await updateCart(matchingIds[0], currentQty);
                }, 500);
            }
        }
    });
};

document.addEventListener('DOMContentLoaded', async () => {
    await changeGiftProduct();
    await addGiftProduct();
    await removeGiftProduct();
});